import {moderator} from "../const/user";

export default function ({store}) {
  const loginUser = store.state?.app?.loginUser;
  if (loginUser?.company !== moderator || loginUser.shop !== moderator) {
    $nuxt.error({statusCode: 404, message: 'この情報は表示できません'});
  }
}
